function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useRef, useState } from 'react';
import Translator from "../components/common/translation";
import { useWorkFlow } from "../components/contexts/workflow";
import { _Environment, WeverCoreContext } from "../services/core";
var EndDiagnostic = function EndDiagnostic(_ref) {
  var _collector$diag;
  var finished = _ref.finished,
    hasNotStarted = _ref.hasNotStarted,
    alias = _ref.alias;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var descFrame = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    frameHeight = _useState2[0],
    setFrameHeight = _useState2[1];
  var endToTranslate = (_collector$diag = collector.diag) === null || _collector$diag === void 0 ? void 0 : _collector$diag.endDescription[locale];
  useEffect(function () {
    if (!(descFrame !== null && descFrame !== void 0 && descFrame.current)) {
      return;
    }
    descFrame.current.addEventListener('load', function (e) {
      setFrameHeight(descFrame.current.contentWindow.document.children[0].offsetHeight + 20);
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "collectorEnd"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collectorHeaderImg d-flex justify-content-end align-items-center"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mx-auto w-75 h-100"
  }, endToTranslate && !hasNotStarted ? /*#__PURE__*/React.createElement("iframe", {
    ref: descFrame,
    title: "descr",
    id: "descr-frame",
    srcDoc: endToTranslate,
    style: {
      width: '100%',
      height: "".concat(frameHeight, "px")
    }
  }) : /*#__PURE__*/React.createElement(Translator, {
    id: finished ? "collectorapp_diag_has_ended".concat(alias) : hasNotStarted ? "collectorapp_diag_not_started".concat(alias) : "end_thanks".concat(alias)
  }), /*#__PURE__*/React.createElement("br", null), finished && _Environment.get('user_url') && /*#__PURE__*/React.createElement("a", {
    className: "btn-wever text-sm",
    href: _Environment.get('user_url')
  }, /*#__PURE__*/React.createElement(Translator, {
    id: "collectorapp_go_to_userapp"
  }))));
};
export default EndDiagnostic;